import type { SearchSourceType as ReaderSearchSourceType } from '@affine/reader';

export { classifyBlockSourceType, type SearchSourceType } from '@affine/reader';

export function isSearchSourceType(
  value: string | undefined
): value is ReaderSearchSourceType {
  return (
    value === 'doc' ||
    value === 'text' ||
    value === 'image' ||
    value === 'edgeless' ||
    value === 'attachment' ||
    value === 'embed' ||
    value === 'database' ||
    value === 'pdf'
  );
}
